import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { audience } from '../../data/content';
export function AudienceSection() {
  return <section id="for-you" className="bg-white px-5 py-14 sm:py-20" data-id="element-16" data-mp="1y8dejcl73ztm">
      <div className="mx-auto max-w-3xl" data-id="element-17" data-mp="1y6iqhpemnrlb">
        <SectionHeading title="Astrologer Ready Was Built for You If..." data-id="element-18" data-mp="1t9946imjbw1p" />
        <ul className="mt-10 space-y-3" role="list" data-id="element-19" data-mp="286t3pa0nwz0h">
          {audience.map(item => <li key={item} className="flex items-start gap-3 border-b border-brand-violet/10 pb-3 text-base leading-relaxed text-brand-ink sm:text-lg" data-id="element-20" data-mp="284gdyaonxkcv">
              <span className="mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-cta text-white" data-id="element-21" data-mp="2gxte9xp23o8z">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="2cyb2brf7qnia" />
              </span>
              {item}
            </li>)}
        </ul>
        <p className="mt-6 text-center text-[15px] leading-relaxed text-brand-ink/65" data-id="element-23" data-mp="2lyz8jzyd7jkm">
          Tarot readers who combine cards with astrology-based client work will also find the preparation workflows, client scripts and deliverable systems useful.
        </p>
      </div>
    </section>;
}